import { createHoneybadger, createReporter } from '@betterplace/error-reporting'

const honeybadger = createHoneybadger({
  apiKey: window.HoneybadgerConfig?.apiKey,
  environment: window.HoneybadgerConfig?.environment,
  revision: window.HoneybadgerConfig?.revision,
  tags: window.HoneybadgerConfig?.tags,
})

export const report = createReporter(honeybadger)
